import React, { useEffect, useState } from 'react'
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import moment from 'moment';

const EditProfile = () => {

    const [profile, setProfile] = useState({ name: "", email: "", start_year: "", end_year: "" });
    // const [firmList, setFirmList] = useState([]);
    const [changePassword, setChangePassword] = useState({ opassword: "", password: "", cpassword: "", opwdShow: true, pwdShow: true, cpwdShow: true });
    const [disable, setDisable] = useState(false);
    const [disable1, setDisable1] = useState(false);
    const [error, setError] = useState({});
    const [errorTwo, setErrorTwo] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        getProfile()
        // eslint-disable-next-line
    }, [navigate]);


    const handleChangePassword = (e) => {
        setChangePassword({ ...changePassword, [e.target.name]: e.target.value });
    }

    const getProfile = () => {
        const myurl = `${PAY_URL}/user/get-profile`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        })
            .then(async (response) => {
                // console?.log("@@", response?.data);
                const data = response.data.data

                setProfile({
                    name: data.user_name,
                    email: data?.email,
                    start_year: moment(data?.year[0]?.start_year).format('YYYY'),
                    end_year: moment(data?.year[0]?.end_year).format('YYYY'),
                })

                // console.log(profile.image, '$$$')
            }).catch((error) => {
                toast.error("Something went wrong");
                console?.log("Errors", error);
            });
    }

    const handleEditProfile = () => {
        if (validation()) {
            setDisable(true);
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('user_name', profile.name);

            axios({
                method: 'post',
                url: `${PAY_URL}/user/update-profile`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
            }).then((response) => {
                if (response.data.success === true) {
                    localStorage.setItem('PAY_USER_NAME', response?.data?.data?.user_name);
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message)
                }
                setDisable(false);
            }).catch((error) => {
                setDisable(false);
                console.log(error);
                toast.error(error?.response?.data?.message);
            })
        }
    }


    const handlePassword = () => {
        if (validate()) {
            setDisable1(true);

            // console.log(changePassword.opassword, "OLD")
            // console.log(changePassword.password, "Passowrd")

            const bodyFormData = new URLSearchParams();
            bodyFormData.append('old_password', changePassword.opassword);
            bodyFormData.append('new_password', changePassword.password);

            axios({
                method: 'post',
                url: `${PAY_URL}/user/change-password`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
            }).then((response) => {
                // console.log(response.data, "@@")
                if (response.data.success === true) {
                    toast.success(response.data.message);
                    setChangePassword({ opassword: "", password: "", cpassword: "", opwdShow: true, pwdShow: true, cpwdShow: true })
                } else {
                    toast.error(response.data.message)
                }
                setDisable1(false);
            }).catch((error) => {
                console.log(error);
                setDisable1(false);
                toast.error(error.response.data.message);
            })
        }
    }

    const validation = () => {
        let isValid = true;
        let err = {};

        if (!profile.name) {
            isValid = false;
            err['name_err'] = "Please enter user name"
        }

        setError(err);
        return isValid
    }

    const validate = () => {
        let isValid = true;
        let err = {};

        if (!changePassword.opassword) {
            isValid = false;
            err["opassword_err"] = "Please enter old password.";
        }

        if (!changePassword.password) {
            isValid = false;
            err['password_err'] = "Please enter password";
        } else {
            const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
            if (!passwordRegex.test(changePassword.password)) {
                isValid = false;
                err['password_err'] = "Password must have at least 8 characters, including one capital letter, one number, and one special character (@$!%*?&)";
            }
        }

        if (!changePassword.cpassword) {
            isValid = false;
            err['cpassword_err'] = "Please enter confirm password"
        }

        if (changePassword.password && changePassword.cpassword) {
            if (changePassword.password !== changePassword.cpassword) {
                isValid = false;
                err['cpassword_err'] = "Password doesn't match";
            }
        }


        setErrorTwo(err);
        return isValid
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">Edit Profile</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Edit Profile</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">
                            <div className="card p-3 basicform">
                                <div className=" mb-3 titleForm border-bottom">
                                    <h4 className="">Edit Profile</h4>
                                </div>

                                <div className="row card_id">
                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label htmlFor="editName" className="form-label">User Name</label>
                                                <input type="text" className="form-control" id="editName"
                                                    value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                                                />
                                                <div className='error'>{error.name_err}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label htmlFor="editImages" className="form-label">Email</label>
                                                <input className="form-control" value={profile?.email} disabled />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label htmlFor="editImages" className="form-label">Year</label>
                                                <input className="form-control" value={`${profile?.start_year}-${profile?.end_year}`} disabled />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className=" col-md-4">
                                    <button className="btn btn-success w-100 p-2" type='button' onClick={handleEditProfile} disabled={disable}>{disable ? 'Processing...' : 'Update'}</button>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">
                            <div className="card p-3 basicform">
                                <div className=" mb-3 titleForm border-bottom">
                                    <h4 className="">Change Password</h4>
                                </div>

                                <div className="row card_id">
                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3 position-relative">
                                                <label htmlFor="currentpassword" className="form-label">Old Password</label>
                                                <input type={changePassword.opwdShow ? "password" : "text"}
                                                    name='opassword' value={changePassword.opassword} onChange={handleChangePassword}
                                                    className="form-control position-relative" id="currentpassword" />
                                                {changePassword.opwdShow ? <div className="input-icon profilePassword" onClick={() => { setChangePassword({ ...changePassword, opwdShow: false }) }}><i className='fa-solid fa-eye' /></div> : <div className='input-icon profilePassword' onClick={() => setChangePassword({ ...changePassword, opwdShow: true })}><i className='fa-solid fa-eye-slash' /> </div>}
                                                <div className='error'>{errorTwo?.opassword_err}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3 position-relative">
                                                <label htmlFor="newPassword" className="form-label">New Password</label>
                                                <input type={changePassword.pwdShow ? "password" : "text"}
                                                    onChange={handleChangePassword} name='password' value={changePassword.password}
                                                    className="form-control position-relative" />
                                                {changePassword.pwdShow ? <div className="input-icon profilePassword" onClick={() => { setChangePassword({ ...changePassword, pwdShow: false }) }}><i className='fa-solid fa-eye' /></div> : <div className='input-icon profilePassword' onClick={() => setChangePassword({ ...changePassword, pwdShow: true })}><i className='fa-solid fa-eye-slash' /> </div>}
                                                <div className='error'>{errorTwo.password_err}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="cardNum">
                                            <div className="mb-3 position-relative">
                                                <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                                                <input type={changePassword.cpwdShow ? "password" : "text"}
                                                    onChange={handleChangePassword} value={changePassword.cpassword} name='cpassword'
                                                    className="form-control position-relative" id="confirmPassword" />
                                                {changePassword.cpwdShow ? <div className="input-icon profilePassword" onClick={() => { setChangePassword({ ...changePassword, cpwdShow: false }) }}><i className='fa-solid fa-eye' /></div> : <div className='input-icon profilePassword' onClick={() => setChangePassword({ ...changePassword, cpwdShow: true })}><i className='fa-solid fa-eye-slash' /> </div>}
                                                <div className='error'>{errorTwo.cpassword_err}</div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className=" col-md-4">
                                    <button className="btn btn-success w-100 p-2" type='button' onClick={handlePassword} disabled={disable1}>{disable1 ? 'Processing...' : 'Submit'}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default EditProfile